// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2hJNb","rootSuccess":"CompleteLink_rootSuccess__2zfnp","rootFailure":"CompleteLink_rootFailure__2EwA8","isDisabled":"CompleteLink_isDisabled__3iSZj"};